import {
  CollectionStore2,
  ConnectionHttpService,
  HttpApiCollectionRepository,
  RepositoryCollectionStore2,
  SOFTLINE_COLLECTION_REPOSITORY,
  Store2Builder,
  SubscriptionStore2
} from '@softline/core';
import { SOFTLINE_API_BELEGVERMERK_ENTITIES } from '@softapps/feichtinger/goldschmiede';
import { InjectionToken } from '@angular/core';
import { Belegvermerk } from '../types/belegvermerk';

const belegvermerkStore = new Store2Builder('belegvermerk')
  .withProvider({
    provide: SOFTLINE_COLLECTION_REPOSITORY,
    useFactory: (service: ConnectionHttpService) =>
      new HttpApiCollectionRepository(service, SOFTLINE_API_BELEGVERMERK_ENTITIES),
    deps: [ConnectionHttpService]
  })
  .withSubFeature('subscription', SubscriptionStore2)
  .withSubFeature('collection', CollectionStore2<Belegvermerk>)
  .withSubFeature('collectionRemote', RepositoryCollectionStore2<Belegvermerk>)

export const BelegvermerkStore = new InjectionToken(
  'BelegvermerkStore',
  {
    providedIn: 'root', factory: () => belegvermerkStore.build()
  }
)